import { PRODUCT_STANDARD_PRO } from '@constant'
import { isUltimate } from '@merchant-backend/util'
import { getProTitle, goPayment } from '@util'
import { Modal } from 'hljd'
import { toJS } from 'mobx'
import { inject } from 'mobx-react'
import React, { Component } from 'react'
import { hashHistory } from 'react-router'

@inject('store')
class index extends Component {
  handleOk = () => {
    const { store } = this.props
    const productPrice = toJS(store.productPrice)
    if (
      productPrice.flagship.is_buy_flagship == 0 ||
      productPrice.standard_to_flagship.is_buy_standard_to_flagship == 0
    ) {
      store.setStoreData('showProtocolModal', true)
      return
    }

    goPayment({
      title: `购买${getProTitle()}`,
      fee: productPrice.flagship.fee,
      product_id: PRODUCT_STANDARD_PRO
    })
  }
  render() {
    const _isUltimate = isUltimate()
    const title = getProTitle()
    return (
      <Modal
        title="提示"
        visible={!_isUltimate}
        onOk={this.handleOk}
        onCancel={() => hashHistory.push('/')}
        cancelText="关闭"
        okText={`升级${title}`}
        closable={false}
        keyboard={false}
        maskClosable={false}
        width={380}
      >
        <div
          style={{
            textAlign: 'center'
          }}
        >
          升级{title}查看详细数据！
        </div>
      </Modal>
    )
  }
}

export default index
